export const SALES_HISTORY_INDICATOR_STATUS_STORAGE_KEY =
  'salesHistoryIndicatorStatusIds';

export interface FilterGroup {
  dataInicial: string;
  dataFinal: string;
  orcamento: string;
  pedido: string;
  filial: string;
  cliente: string;
  vendedor: string;
  checkboxData: string[];
}
